import { IApplicationState } from '../../types/redux';

export function isNewbuildingChatOpenedSelector(state: IApplicationState) {
  return state.newbuildingChat.isOpen;
}
